import { isBuiltLoadBuildingSuggestion } from 'components/Kit/BuiltLoads/utils/isBuiltLoadBuildingSuggestion';
import { LoadBuildingSuggestions } from 'types/suggestions/LoadBuildingSuggestions';
import { isKitSuggestionActionable } from 'utils/completeKitSuggestion';

// Single "the rep still needs to build this load" check for load building cards. The card is
// Pending or InFlight, and not already built in Drumkit or found in the TMS. A built card alone never
// pulls the rep to the Load Building tab or lights up the New pulse.
export function isLoadBuildingSuggestionActionable(
  suggestion: LoadBuildingSuggestions
): boolean {
  return (
    !isBuiltLoadBuildingSuggestion(suggestion) &&
    isKitSuggestionActionable(suggestion)
  );
}
